// src/components/ProtectedRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../firebase";

const ProtectedRoute = ({ children }) => {
  const [user, loading] = useAuthState(auth);

  if (loading) return <div>Loading...</div>;

  // You can add additional admin logic here (e.g., check user.email)
  if (!user || user.email !== "intosoundhealing@gmail.com") {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
